(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './MultiplatformSettings-multiplatform-settings.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./MultiplatformSettings-multiplatform-settings.js'));
  else {
    if (typeof globalThis['MultiplatformSettings-multiplatform-settings'] === 'undefined') {
      throw new Error("Error loading module 'MultiplatformSettings-multiplatform-settings-no-arg'. Its dependency 'MultiplatformSettings-multiplatform-settings' was not found. Please, check whether 'MultiplatformSettings-multiplatform-settings' is loaded prior to 'MultiplatformSettings-multiplatform-settings-no-arg'.");
    }
    globalThis['MultiplatformSettings-multiplatform-settings-no-arg'] = factory(typeof globalThis['MultiplatformSettings-multiplatform-settings-no-arg'] === 'undefined' ? {} : globalThis['MultiplatformSettings-multiplatform-settings-no-arg'], globalThis['MultiplatformSettings-multiplatform-settings']);
  }
}(function (_, kotlin_com_russhwolf_multiplatform_settings) {
  'use strict';
  //region block: imports
  var StorageSettings = kotlin_com_russhwolf_multiplatform_settings.$_$.a;
  //endregion
  //region block: pre-declaration
  //endregion
  function Settings() {
    return new StorageSettings();
  }
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = Settings;
  //endregion
  return _;
}));

//# sourceMappingURL=MultiplatformSettings-multiplatform-settings-no-arg.js.map
